import { useTranslation } from 'react-i18next';
import Dialog from '../../../../../../../common/widgets/Dialog';
import Icons from '../../../../../../../common/widgets/Icons';
import { resources } from '../../../../../resources/resources';

interface SuggestionSavedDialogProps {
  close: () => void;
}

export default function SuggestionSavedDialog(
  props: Readonly<SuggestionSavedDialogProps>,
) {
  const { t: translate } = useTranslation();
  const { close } = props;
  return (
    <Dialog
      closeDialog={() => close()}
      closeOnClickOutside
      showCloseIcon
      className="dialog-s"
    >
      <div className="dialog-content feedback-dialog">
        <div className="dialog-image">
          <Icons.Success />
        </div>

        <div className="dialog-title">
          {translate(resources.searchPage.noResults.success.title)}
        </div>

        <div className="dialog-text centered">
          {translate(resources.searchPage.noResults.success.message)}
        </div>
      </div>
    </Dialog>
  );
}
